module.exports = __webpack_public_path__ + "static/media/github.ad6e566f.svg";